import React from 'react'
import logo from '../img/logo/logo.png'
import logo_sm from '../img/logo/logo-sm.png'

const Header = () => {
  return (<header className="navbar navbar-sticky bg-primary">
    <div className="site-branding">
      <a className="site-logo hidden-xs-down" href="/ddjj/confirmacion-cuit">
        <img src={logo} alt="Municipio de Berisso"/>
      </a>
      <a className="site-logo logo-sm hidden-sm-up" href="/">
        <img src={logo_sm} alt="Municipio de Berisso"/>
      </a>
    </div>
  </header>)
}

export default Header
